export interface IAssetConfigs {
  asset: string;
  instrument_type: string;
  account: string;
  initial_margin: string;
  maintenance_margin: string;
  portfolio_initial_margin: string;
  portfolio_maintenance_margin: string;
  taker_fee: string;
  maker_fee: string;
  premium_cap: string;
  liquidation_fee: string;
  liquidation_fee_cap: string;
}

export type ExternalFundingVenue = "BinanceFunding" | "ByBitFunding" | "HyperliquidFunding";

export const EXTERNAL_FUNDING_VENUES: ExternalFundingVenue[] = [
  "BinanceFunding",
  "ByBitFunding",
  "HyperliquidFunding",
];

export interface IGlobalAssetConfigs extends IAssetConfigs {
  price_step_size: string;
  amount_step_size: string;
  min_amount: string;
  max_amount: string;
  max_notional: string;
  price_band: string;
  price_band_index: string;
  insurance_fund: string;
  fair_impact_tolerance: string;
  liquidation_max_slippage: string;
  fair_impact_notional: string;
  max_open_interest: string;
  max_insurance_position: string;
  external_funding_weight: string;
  external_funding_venue: ExternalFundingVenue;
  is_rwa: boolean;
  market_type: string;
  rwa_price_band_enabled: boolean;
  rwa_price_band_anchor: string;
  rwa_absolute_band: string;
}

export const CONFIG_TITLES: Partial<Record<keyof IAssetConfigs, string>> = {
  initial_margin: "Initial Margin",
  maintenance_margin: "Maintenance Margin",
  portfolio_initial_margin: "Portfolio Initial Margin",
  portfolio_maintenance_margin: "Portfolio Maintenance Margin",
  taker_fee: "Taker Fee",
  maker_fee: "Maker Fee",
  premium_cap: "Premium Cap",
  liquidation_fee: "Liquidation Fee",
  liquidation_fee_cap: "Liquidation Fee Cap",
};

export const ADMIN_CONFIG_TITLES: Partial<
  Record<keyof IGlobalAssetConfigs, string>
> = {
  price_step_size: "Price Step Size",
  amount_step_size: "Amount Step Size",
  min_amount: "Min. Amount",
  max_amount: "Max. Amount",
  max_notional: "Max. Notional",
  price_band: "Price Band",
  price_band_index: "Price Band Index",
  insurance_fund: "Insurance Fund",
  fair_impact_tolerance: "Fair Impact Tolerance",
  max_open_interest: "Max Open Interest (USD)",
  liquidation_max_slippage: "Liquidation Max Slippage",
  fair_impact_notional: "Fair Impact Notional",
  max_insurance_position: "Insurance Fund Max Notional (USD)",
  external_funding_weight: "External Funding Weight",
  external_funding_venue: "External Funding Venue",
};

export const RWA_CONFIG_TITLES: Partial<
  Record<keyof IGlobalAssetConfigs, string>
> = {
  rwa_price_band_enabled: "RWA Price Band Enabled",
  rwa_price_band_anchor: "RWA Price Band Anchor",
  rwa_absolute_band: "RWA Absolute Band",
};
